import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import { convertStringToElements } from "@vds/html-parsers";

import { fetchPageContent } from "../DownloadAndDelete/actions";
import { setA11yContent } from "../NavigationHelper/actions";
import { ENDPOINTS } from "utils/endpoints";
import { checkNestedObject } from "utils/checkNestedObject";
import { checkAMLob } from "utils/checkAMLob";

//import API from "../../../../../Services/API";
//import { PENDING_CASE_FAILURE } from "../../ActiveCustomer/actions/types";
//import { GENERIC_ERROR_MESSAGE } from "./actions/types";

//import { checkPendingCases, createUpdateProfile, createDocVerification } from "../../ActiveCustomer/actions/commonActiveCustomerAPI";

import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";
import Header from "common-components/Header";
// import { fetchCustomerHistory } from "./actions";
import Container from "common-components/Container";
import { agentSelectCustomer } from "./actions"
import RectangleLoader from "common-components/RectangleLoader";
import Button from "common-components/Buttons";
import { FormerPendingRequest } from "../FormerCustomer/FormerPendingRequest";
import { checkPendingCases, createUpdateProfile, createDocVerification } from "../FormerCustomer/actions/commonFormerCustomerAPI";
// import AuthorizedAgentSubmitProof from "./AuthorizedAgentSubmitProof";

class AuthorizedAgentSubmitProof extends Component {
  state = {
    loading: true,
    pendingModal: false,

    submitProofPageTitle: '',
    submitProofHeader: '',
    submitProofDescription: '',

    submitProofAppeal: ''

  };



  // createServiceHeader = {
  //     "intent": "ResidencyProof", 
  //     "processStep": "CheckPendingCase",
  //     "identifier": "mtn",
  //     "value": this.props.history.location.state.agentSelectedCustomer.mtn
  //   };

  componentDidMount() {
    const url = ENDPOINTS.FETCH_AUTHORIZED_AGENT_LANDING_PAGE;
    this.props.fetchPageContent(url).then(() => {
      this.setState({ loading: false });

      if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
        this.props.setA11yContent("Submit proof of residency", this.props.pageContent.appeal_proof[1].sc_pagetitle);
      }

      if (checkNestedObject(this.props, "pageContent", "breadCrumbs", "landingPage")) {
        const { landingPage, submitAppeal } = this.props.pageContent.breadCrumbs;
        this.props.setBreadcrumbList([
          { label: landingPage, path: "/privacy/secure/authorized-agent" },
          { label: submitAppeal, path: "/privacy/secure/authorized-agent/customer/submit-appeal" }
        ]);
      }
    });
  }

  handleContinueBtn = () => {
    const checkUser = checkAMLob();
    const checkMtn = this.props.history.location.state.agentSelectedCustomer.mtn;

    var datas = {
      emailId: '',
      firstName: '',
      lastName: '',
      startDate: '',
      endDate: '',
      action: '',
      flow: "timeFrameSelection",
      uuid: '',
      serviceType: '',
      formerId: '',
      accountId: ''
    }

    this.props.checkPendingCases(null, null, null, null, null, null, checkUser, checkMtn).then(() => {

      if (!this.props.error) {

        if (this.props.isCasePending) {
          this.setState({ pendingModal: true })
        }
        else {
          this.props.createUpdateProfile(datas, checkUser, checkMtn).then(() => {
            if (!this.props.error) {
              //next();
              //this.props.createDocVerification().then()
              //this.props.createDocVerification();
              let isMitekDoc = "Y";
              let processActionValue = "GetEnforceLink";
              var DocVerifyData = {
                caseId: this.props.caseId,
                email: '',
                processAction: processActionValue,
                applicationId: '',
                intent: '',
                serviceType: '',
                isOptOut: '',
                isMitekDoc: isMitekDoc ? isMitekDoc : null
              }
              this.props.createDocVerification(DocVerifyData, checkUser, checkMtn).then(() => {
                if (!this.props.error) {
                  return (window.location.href = `${this.props.gemaltoLink}`);
                }
              })
            } else {
              // /alert('Test');
              this.setState({ pendingModal: true })

            }
          })
        }
      }
    })

  }

  render() {
    if (this.props.loading || this.state.loading) {
      return <RectangleLoader />;
    }

    if (!this.props.pageContent) {
      return <Redirect to="/privacy/secure/authorized-agent" />;
    }


    //Agent
    const appeal_details = this.props.pageContent.appeal_proof[1];
    const section_details = appeal_details;


    const category_details = appeal_details.Category[0];

    const { section_title } = section_details;

    const { category_description } = category_details;

    const modalContent = this.props.pageContent.appeal_proof[2];

    return (
      <Container>
        <Header>{section_title}</Header>

        <p style={{ marginTop: "26px", marginBottom: "45px", maxWidth: "665px" }}> {convertStringToElements(category_description)}  </p>
        <Button
          background={appeal_details.buttons[0].type}
          role="link"
          onClick={this.handleContinueBtn}
        >
          {appeal_details.buttons[0].text}
        </Button>

        {this.state.pendingModal ?
          <FormerPendingRequest
            modalContent={modalContent}
            dateOfRequest={"date"}
            closeModal={() => {
              this.setState({
                pendingModal: !this.state.pendingModal
              }, () => {
                if (this.props.BreadCrumbsLink && this.props.BreadCrumbsLink[1] && this.props.BreadCrumbsLink[1].requestHistoryPageName) {
                  this.props.history.push(this.props.BreadCrumbsLink[1].requestHistoryPageName)
                }
              })
            }}

          /> : ""
        }
      </Container>
      //   onClick={() =>


      //     this.props.history.push({
      //       pathname: "",
      //       state: { confirmAuth: true, nextRoute: "" }
      //     })
      //   }
    );
  }
}
AuthorizedAgentSubmitProof.propTypes = {
  fetchPageContent: PropTypes.func.isRequired,
  setA11yContent: PropTypes.func.isRequired,
  pageContent: PropTypes.object,
  loading: PropTypes.bool
};

const mapStateToProps = ({
  pageContent,
  loadingAndErrorState: { loading, error },
  pendingCase: { isCasePending },
  formerVerifyIdData: { gemaltoLink },
  agentCustomerHistory: {
    agentDetailsData
  },
  caseCreation: { caseId }
}) => ({
  pageContent: pageContent,
  loading,
  error,
  isCasePending,
  gemaltoLink,
  agentDetailsData,
  caseId
});

export default connect(
  mapStateToProps,
  { setA11yContent, fetchPageContent, agentSelectCustomer, setBreadcrumbList, checkPendingCases, createUpdateProfile, createDocVerification }
)(AuthorizedAgentSubmitProof);
